import {translator} from "../services/TranslatorService";

export class EventHelper {
	constructor() {}

	setActivePlaces(carts) {
		const placeWithoutName = $("#js-places").data("place-without-name");

		$.each(carts, (index, cart) => {
			const selector = $(`#${cart.sid}`);

			selector.attr("data-price", cart.price);
			selector.attr("is_pack", cart.is_pack ? "true" : "false");

			selector.addClass("in-cart active");
			if (!placeWithoutName)
				selector.attr(
					"data-name",
					cart.is_pack
					  ? translator.t("event", cart.sector)
					  : this.createPlaceName(
						  this.splitPlaceId(cart.sid),
						  cart.sector
						)
				  );
			// Даёт возможность бронить упакованные места сколько угодно раз
			if (!cart.is_pack) selector.attr("data-available", "false");
		});
	}

	removeActivePlaces(carts) {
		$.each(carts, (index, cart) => {
			$(`#${cart.sid}`).removeClass("in-cart").attr("data-available", "true");
		});
	}

	setActivePlaceBySid(sid) {
		return $(`#${sid}`).addClass("in-cart active").attr("data-available", "false");
	}

	removeActivePlaceBySid(sid) {
		return $(`#${sid}`).removeClass("in-cart").attr("data-available", "true");
	}

	/**
	 * Обновляет цены на плане
	 * @param {Object} sectorData
	 * @param {Array<import("../api/rest/event").Price>} sectorData.prices
	 * @param {Array<import("../api/rest/event").Zone>} sectorData.zones
	 * @param {Object<string, import("../api/rest/event").PlacesParamsItem} [sectorData.places_params] - список мест с параметрами где ключ сид
	 */
	setAttributesToPlaces(sectorData) {
		$("#js-change-svg g[mode=2]").addClass("default");

		$.each(sectorData.prices, (index, element) => {
			const id = element.id;
			const zone = this.getZonePropertiesById(element.z, sectorData.zones);
			const price = zone ? zone.price : 0;
			const selector = $(`#${id}`);
			const placeWithoutName = $("#js-places").data("place-without-name");

			if(!selector.attr("data-name")) {
				if (!placeWithoutName)
					selector.attr(
						"data-name",
						sectorData.places_params && sectorData.places_params[id]
							? this.createPlaceName([
									sectorData.places_params[id].col,
									sectorData.places_params[id].row,
							  ])
							: element.n
							? translator.t("event", element.n)
							: this.createPlaceName(this.splitPlaceId(id))
					);
			}
			selector.attr("data-price", price);
			selector.attr("zone", element.z);

			selector.removeClass("default").addClass("active");
		});

		$.each(sectorData.zones, (index, element) => {
			$(`[zone="${element.zone}"]`).find("rect").css("fill", element.color);
			$(`[zone="${element.zone}"]`).find("ellipse").css("fill", element.color);
			$(`[zone="${element.zone}"]`).find("circle").css("fill", element.color);
			$(`[zone="${element.zone}"]`).find("polygon").css("fill", element.color);
		});
	}

	/**
	 * Добавляет price атрибут для секторов
	 * @return {Array} - список секторов
	 */
	setPriceAttributeToSectors() {
		$.each($("g[price_min]"), (i, sector) => {
			const price_min = $(sector).attr("price_min");
			const price_max = $(sector).attr("price_max");

			if ($(sector).attr("price")) return false;

			if (price_min === price_max) {
				$(sector).attr("price", price_min);
			} else {
				$(sector).attr("price", [].concat(price_min, price_max).join());
			}
		});

		return $("g[price]");
	}

	/**
	 * Разбивает id места на массив значении
	 * @param {String} id - Строка в виде: s3r5p20
	 * @return {Array} - Возвращает массив в виде: [Место, Ряд, Сектор]
	 */
	splitPlaceId(id) {
		return id
			.split(/[^\d]/)
			.filter(element => element !== "")
			.reverse();
	}

	/**
	 * Создает название для места (например для тултипа)
	 * @param {string[]} values - Массив значении в виде: [Место, Ряд, Сектор]
	 * @return {string} - Возвращает строку в виде: Ряд 3, место 21
	 */
	createPlaceName(values, sector = null) {
		if (!values[1]) return ``;
	  
		const row = values[1];
		const place = values[0];
	  
		const lang = document.documentElement.lang;
	  
		if (lang === "ru") {
		  return sector
			? `${sector} ряд ${row} место ${place}`
			: `Ряд ${row}, место ${place}`;
		}
	  
		return sector
		  ? `${sector} Row ${row}, place ${place}`
		  : `${translator.t("event", "Row")} ${row}, ${translator.t("event", "place")} ${place}`;
	  }

	/**
	 * Возвращает значения зоны для получения цен и цвета
	 * @param {Number} zoneId - Номер зоны
	 * @param {Array} zones - Список зон
	 * @return {Object}
	 */
	getZonePropertiesById(zoneId, zones) {
		return zones.filter(element => element.zone === zoneId)[0];
	}

	getZonesByUniquePrices(uniquePrices, zones) {
		return zones.filter(zone => uniquePrices.filter(price => zone.zone === price.z).length > 0);
	}

	isStadiumPlan(svg = null) {
		const $svg = svg || $("#js-change-svg svg");

		return $svg.find("g[mode=1]").length > 0;
	}

	hasPlanPlaces() {
		return $("#js-change-svg svg").find("g[mode='2']").length > 0;
	}

	/**
	 * Выводит название сектора по g элементу
	 * например: "Сектор А5"
	 * @param $activeSector
	 * @return {String}
	 */
	getSectorNameOfGElement($activeSector) {
		return $activeSector.attr("sector_name") || $activeSector.attr("sector-name");
	}

	/**
	 * Выводит цены сектора по g элементу
	 * например: "500₽" или "500₽ — 1000₽"
	 * @param $activeSector
	 * @return {String}
	 */
	getSectorPriceOfGElement($activeSector) {
		const price = $activeSector.attr("price");
		const price_min = $activeSector.attr("price_min");
		const price_max = $activeSector.attr("price_max");

		if (!(price || price_min)) return ``;

		if (price) return `${price}  ₽`;

		return price_min === price_max ? `${price_min} ₽` : `${price_min} ₽ — ${price_max} ₽`;
	}

	disableZeroPriceSectors(sectors) {
		const noneZeroSectors = [];

		if (!$("g[price]").length > 0) this.setPriceAttributeToSectors();

		$.each(sectors, (i, sector) => {
			if (parseInt($(sector).attr("price")) !== 0) noneZeroSectors.push(sector);
		});

		/* Если все нулевые то оставляем без изменения */
		if (noneZeroSectors.length === 0) return false;

		return $("g[price=0]").addClass("disabled");
	}
}

export const eventHelper = new EventHelper();
